
import { useState } from 'react';
// import { Link } from 'react-router-dom'; // Hidden: View Details button
import { takeoffServices } from '../../../mocks/takeoffServices';
import RequestQuotePopup from '../../../components/feature/RequestQuotePopup';

export default function TakeoffServices() {
  const [quoteService, setQuoteService] = useState<string | null>(null);

  return (
    <>
      <section className="py-20 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 bg-orange-50 text-[#e18033] px-4 py-2 rounded-full text-sm font-semibold mb-4">
              <i className="ri-calculator-line"></i>
              <span>3 Core Services</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Accurate Takeoff &amp; Estimation
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Precise quantity takeoffs and cost analysis to help you bid competitively and manage project budgets effectively
            </p>
          </div>

          <div className="space-y-8">
            {takeoffServices.map((service, index) => (
              <div
                key={service.id}
                className={`bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                  } flex flex-col lg:flex`}
              >
                <div className="lg:w-1/2 h-80 lg:h-auto w-full">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-contain object-center p-4"
                  />
                </div>

                <div className="lg:w-1/2 p-8 lg:p-12 flex flex-col justify-center">
                  <div className="inline-flex items-center gap-2 bg-orange-50 text-[#e18033] px-3 py-1.5 rounded-full text-xs font-semibold mb-4 w-fit">
                    <span>Service {service.id}</span>
                  </div>

                  <h3 className="text-3xl font-bold text-gray-900 mb-4">
                    {service.title}
                  </h3>

                  <p className="text-base text-gray-600 mb-6 leading-relaxed whitespace-pre-line">
                    {service.description}
                  </p>

                  <div className="grid grid-cols-2 gap-3 mb-6">
                    {service.features.map((feature, idx) => (
                      <div key={idx} className="flex items-start gap-2">
                        <i className="ri-check-line text-[#e18033] text-lg mt-0.5 flex-shrink-0"></i>
                        <span className="text-sm text-gray-700">{feature}</span>
                      </div>
                    ))}
                  </div>

                  <div className="flex flex-wrap gap-2 mb-6">
                    {service.tags.map((tag, idx) => (
                      <span
                        key={idx}
                        className="text-xs bg-gray-100 text-gray-700 px-3 py-1.5 rounded-full"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>

                  <div className="mt-auto pt-6 border-t border-gray-50">
                    {/* View Details button hidden for now
                    <Link
                      to={`/service/${service.title.toLowerCase().replace(/\s+/g, '-').replace(/[&/]/g, '')}`}
                      className="inline-flex items-center justify-center px-6 py-3 rounded-lg font-semibold border-2 border-[#e18033] text-[#e18033] hover:bg-orange-50 transition-colors cursor-pointer text-sm w-full sm:w-auto"
                    >
                      View Details
                      <i className="ri-arrow-right-line ml-2"></i>
                    </Link>
                    */}
                    <button
                      onClick={() => setQuoteService(service.title)}
                      className="inline-flex items-center text-[#e18033] font-semibold text-sm group/btn cursor-pointer hover:text-[#c97029] transition-colors"
                    >
                      Request Quote
                      <i className="ri-arrow-right-line ml-2 transition-transform group-hover/btn:translate-x-1"></i>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Request Quote Popup */}
      <RequestQuotePopup
        isOpen={!!quoteService}
        onClose={() => setQuoteService(null)}
        serviceName={quoteService || undefined}
      />
    </>
  );
}
